
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recover-password",
      function () {
        return require("private-next-pages/recover-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recover-password"])
      });
    }
  